import { useEffect, useRef, useState } from "react";
import {
  Box,
  HStack,
  Image,
  Pressable,
  Spinner,
  Text,
  VStack,
  useMediaQuery,
} from "native-base";
import CryptoJS from "crypto-js";
import MobileHeader from "../../../layout/header/mobileHeader";
import WebHeader from "../../../layout/header/webHeader";
import { COLORS } from "../../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";
import Breadcrumbs from "../../../components/breadcrumb";
import CommonHeading from "../../../components/headings";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../utils/fonts";
import CustomButton from "../../../components/button";
import { hasPermission } from "../../../utils/permission";
import {
  approvePackagesAPI,
  deletePackagesAPI,
  updatePackagesAPI,
} from "../../../api/apis/vendor";
import { LoaderAnimation } from "../../../components/spinner";
import { Toaster } from "../../../components/toaster";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { activeEventTab } from "../../../store/reducers/eventSlice";
import CustomModal from "../../../components/modal";
import MobileModelSheet from "../../../components/actionSheet";
import { photoSelectedTickSVG, photoTickIconSVG } from "../../../utils/svg";
import Svg from "react-native-svg";
import DividerLine from "../../../components/divider";
import FileUploader from "../../../containers/fileUpload";
import NewTextAreaField from "../../../components/textArea/newTextArea";
import InputField from "../../../components/input";
import { uploadFileAPI } from "../../../api/apis/workflow";
import config from "../../../utils/config";
import ViewUploadImageCards from "../../../containers/viewUploadImageCards";

const PackagesDetailsPage = ({ link_type }) => {
  const childRef = useRef();
  const toaster = Toaster();
  const dispatch = useDispatch();
  const [redirect, setRedirect] = useState(false);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: {
      name: "Package Detail",
      path:
        link_type === "PACKAGE_DETAIL" ? "/package-detail" : "/packages-detail",
    },
    activeActivePage: { name: "", path: "" },
  };
  const [actionName, setActionName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState("");
  const [editPackage, setEditPackage] = useState({});
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("package"),
    config.packageKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const packageDetail = JSON.parse(jsonString);
  const [isLoading, setIsLoading] = useState(true);
  const [uploadImages, setUploadImages] = useState("");
  const [forceRemount, setForceRemount] = useState(false);

  useEffect(() => {
    link_type !== "PACKAGE_DETAIL" && dispatch(activeEventTab("packages"));
    if (Object.keys(packageDetail).length === 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [link_type, packageDetail]);

  if (redirect) {
    return <Redirect to={"/home"} />;
  }

  const openModal = () => {
    setShowModal(true);
    setForceRemount(!forceRemount);
  };

  const closeModal = () => {
    setSelectedImageIndex("");
    setShowModal(false);
    setForceRemount(!forceRemount);
  };

  const handleSelectedImages = (index) => {
    setFiles([]);
    setUploadImages("");
    let selectInd = [];
    if (selectedImageIndex.length > 0 && selectedImageIndex.includes(index))
      selectInd = selectedImageIndex.filter((image) => image !== index);
    else selectInd = [index];
    setSelectedImageIndex(selectInd);
  };

  const handleImageChange = (files) => {
    setFiles(files);
    const imageUrls = Array.from(files).map((file) =>
      URL.createObjectURL(file)
    );
    setUploadImages(imageUrls);
  };

  const onDeleteImage = (ind) => {
    setSelectedImageIndex("");
    setUploadImages("");
    setFiles([]);
  };

  const onInputChange = (e, eName) => {
    let data = editPackage;
    data[eName] = e.target.value;
    setEditPackage(data);
  };

  const uploadFilesToServer = async (data, type) => {
    let docs = [];
    let res = await uploadFileAPI(data, type, type);
    res.map((item) => {
      if (item.error) {
        toaster("Upload file failed", "error", "error");
        return;
      }
      if (item.data.data.data) {
        docs.push({
          file_size: item.data.data.data.file_size.toString(),
          file_name: item.data.data.data.file_name,
          media_id: item.data.data.data.media_id,
          name: item.data.data.data.doc_type,
        });
      }
    });
    return docs;
  };

  const handleAction = async (action_name) => {
    LoaderAnimation.show();
    if (action_name === "delete") {
      let payload = {
        package_ids: [
          {
            package_id: packageDetail._id,
          },
        ],
      };
      let res = await deletePackagesAPI(payload);
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        toaster("Package Deleted Successfully", "success", "success");
        // getPackagesListing();
      }
    } else {
      let payload;
      if (action_name === "approve") {
        payload = {
          packages: [
            {
              package_id: packageDetail._id,
              status: "package_approved",
            },
          ],
        };
      } else if (action_name === "reject") {
        payload = {
          packages: [
            {
              package_id: packageDetail._id,
              status: "package_rejected",
            },
          ],
        };
      }
      let res = await approvePackagesAPI(payload);
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        if (action_name === "approve")
          toaster("Package Approved Successfully", "success", "success");
        else if (action_name === "reject")
          toaster("Package Rejected Successfully", "success", "success");
        //   getPackagesListing();
      }
    }
    LoaderAnimation.hide();
    setRedirect(true);
  };

  const getPopupModalTitle = () => {
    if (actionName === "edit") return <Text>Edit Package</Text>;
    else return <Text textTransform={"capitalize"}>{actionName} Package</Text>;
  };

  const getModalChildren = () => {
    if (actionName === "edit") {
      return (
        <HStack
          width={"100%"}
          space={8}
          direction={MobileWindow ? "column" : "row"}
        >
          <VStack space={5} width={!MobileWindow && "49%"}>
            <Box>
              <Text
                fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                mb={2}
              >
                Package Details
              </Text>
              <Box mb={3}>
                <InputField
                  name="package_name"
                  value={editPackage["package_name"]}
                  label="Package Name"
                  placeholder="Enter Package Name"
                  onChange={onInputChange}
                  // ref={childref}
                />
              </Box>
              <Box>
                <NewTextAreaField
                  name="description"
                  value={editPackage["description"]}
                  onChange={onInputChange}
                  label="Package Description"
                  placeholder="Enter Package Description"
                  ref={childRef}
                />
              </Box>
            </Box>
            {!MobileWindow && (
              <Box>
                <Text
                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                >
                  Select Dummy Banner Placeholder
                </Text>
                <HStack space={3} mt={4}>
                  <Box width={"100px"} height={"80px"}>
                    <Image
                      src={config.bucketPath + config.dummyBanner1url}
                      width={"100%"}
                      height={"100%"}
                      resizeMode="stretch"
                    />
                    <Pressable
                      onPress={() => {
                        handleSelectedImages(1);
                      }}
                      zIndex="99"
                      position="absolute"
                      right={0}
                      p={0.5}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: MobileWindow ? "3px" : 0,
                        backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                      }}
                    >
                      <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                        {selectedImageIndex.length > 0 &&
                        selectedImageIndex.includes(1)
                          ? photoSelectedTickSVG
                          : photoTickIconSVG}
                      </Svg>
                    </Pressable>
                  </Box>
                  <Box width={"100px"} height={"80px"}>
                    <Image
                      src={config.bucketPath + config.dummyBanner2url}
                      width={"100%"}
                      height={"100%"}
                      resizeMode="stretch"
                    />
                    <Pressable
                      onPress={() => {
                        handleSelectedImages(2);
                      }}
                      zIndex="99"
                      position="absolute"
                      right={0}
                      p={0.5}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: MobileWindow ? "3px" : 0,
                        backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                      }}
                    >
                      <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                        {selectedImageIndex.length > 0 &&
                        selectedImageIndex.includes(2)
                          ? photoSelectedTickSVG
                          : photoTickIconSVG}
                      </Svg>
                    </Pressable>
                  </Box>
                  <Box width={"100px"} height={"80px"}>
                    <Image
                      src={config.bucketPath + config.dummyBanner3url}
                      width={"100%"}
                      height={"100%"}
                      resizeMode="stretch"
                    />
                    <Pressable
                      onPress={() => {
                        handleSelectedImages(3);
                      }}
                      zIndex="99"
                      position="absolute"
                      right={0}
                      p={0.5}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: MobileWindow ? "3px" : 0,
                        backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                      }}
                    >
                      <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                        {selectedImageIndex.length > 0 &&
                        selectedImageIndex.includes(3)
                          ? photoSelectedTickSVG
                          : photoTickIconSVG}
                      </Svg>
                    </Pressable>
                  </Box>
                </HStack>
              </Box>
            )}
          </VStack>
          <Box width={!MobileWindow && "48%"}>
            <Text
              fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              // mb={2}
            >
              Upload Banner Image
            </Text>
            <FileUploader
              files={files}
              show={false}
              setFiles={handleImageChange}
              accept={["png", "jpg", "jpeg"]}
              types={".png, .jpg, .jpeg"}
              imageRestriction={true}
              isDisabled={selectedImageIndex.length > 0 && true}
              forceRemount={forceRemount}
            />
            {uploadImages && (
              <HStack flex={1} flexWrap={"wrap"}>
                <ViewUploadImageCards
                  ind={0}
                  url={uploadImages}
                  onDeleteImage={onDeleteImage}
                  resizeMode={false}
                />
              </HStack>
            )}
            <Text
              fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
              color={COLORS.LABEL_TEXT_COLOR}
            >
              NOTE: Preferable banner size 250X360px
            </Text>
          </Box>
          {MobileWindow && (
            <Box>
              <HStack
                alignItems={"center"}
                justifyContent={"space-between"}
                mb={5}
              >
                <Box width={"43%"}>
                  <DividerLine direction="horizontal" />
                </Box>
                <Text
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  color={COLORS.PACKAGE_DETAILS_TEXT_COLOR}
                >
                  or
                </Text>
                <Box width={"43%"}>
                  <DividerLine direction="horizontal" />
                </Box>
              </HStack>
              <Text
                fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              >
                Select Dummy Banner Placeholder
              </Text>
              <HStack mt={4} flexWrap={"wrap"}>
                <Box width={"100px"} height={"80px"} mr={3} mb={3}>
                  <Image
                    src={config.bucketPath + config.dummyBanner1url}
                    width={"100%"}
                    height={"100%"}
                    resizeMode="stretch"
                  />
                  <Pressable
                    onPress={() => {
                      handleSelectedImages(1);
                    }}
                    zIndex="99"
                    position="absolute"
                    right={1}
                    p={0.5}
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: MobileWindow ? "3px" : 0,
                      backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                    }}
                  >
                    <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                      {selectedImageIndex.length > 0 &&
                      selectedImageIndex.includes(1)
                        ? photoSelectedTickSVG
                        : photoTickIconSVG}
                    </Svg>
                  </Pressable>
                </Box>
                <Box width={"100px"} height={"80px"} mr={3} mb={3}>
                  <Image
                    src={config.bucketPath + config.dummyBanner2url}
                    width={"100%"}
                    height={"100%"}
                    resizeMode="stretch"
                  />
                  <Pressable
                    onPress={() => {
                      handleSelectedImages(2);
                    }}
                    zIndex="99"
                    position="absolute"
                    right={1}
                    p={0.5}
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: MobileWindow ? "3px" : 0,
                      backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                    }}
                  >
                    <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                      {selectedImageIndex.length > 0 &&
                      selectedImageIndex.includes(2)
                        ? photoSelectedTickSVG
                        : photoTickIconSVG}
                    </Svg>
                  </Pressable>
                </Box>
                <Box width={"100px"} height={"80px"} mr={3} mb={3}>
                  <Image
                    src={config.bucketPath + config.dummyBanner3url}
                    width={"100%"}
                    height={"100%"}
                    resizeMode="stretch"
                  />
                  <Pressable
                    onPress={() => {
                      handleSelectedImages(3);
                    }}
                    zIndex="99"
                    position="absolute"
                    right={1}
                    p={0.5}
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: MobileWindow ? "3px" : 0,
                      backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                    }}
                  >
                    <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                      {selectedImageIndex.length > 0 &&
                      selectedImageIndex.includes(3)
                        ? photoSelectedTickSVG
                        : photoTickIconSVG}
                    </Svg>
                  </Pressable>
                </Box>
              </HStack>
            </Box>
          )}
        </HStack>
      );
    } else {
      return (
        <Box justifyContent={"center"} alignItems={"center"} mt={"20px"}>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            Are you sure, want to {actionName} this package?
          </Text>
        </Box>
      );
    }
  };

  const getModalFooter = () => {
    if (actionName === "edit") {
      return (
        <Box width={MobileWindow && "100%"}>
          <CustomButton
            onPress={async () => {
              LoaderAnimation.show();
              let description = childRef.current.onSubmitInput();
              if (description["value"] && description["value"].length > 5000) {
                toaster(
                  "Please enter package description less than 5000 characters",
                  "error",
                  "error"
                );
                LoaderAnimation.hide();
                return;
              }
              if (
                editPackage["package_name"] &&
                editPackage["package_name"].length > 500
              ) {
                toaster(
                  "Please enter package name less than 500 characters",
                  "error",
                  "error"
                );
                LoaderAnimation.hide();
                return;
              }
              if (
                (files.length > 0 || selectedImageIndex.length > 0) &&
                editPackage["package_name"] &&
                description["value"]
              ) {
                let docs = [];
                if (files.length > 0 && files[0].lastModified) {
                  docs = await uploadFilesToServer(files, "image");
                } else if (files.length > 0) {
                  docs = files;
                } else if (selectedImageIndex.length > 0) {
                  let image = "",
                    name = "";
                  if (selectedImageIndex.includes(1)) {
                    image = config.dummyBanner1url;
                    name = "Dummy Banner-Package_1.png";
                  } else if (selectedImageIndex.includes(2)) {
                    image = config.dummyBanner2url;
                    name = "Dummy Banner-Package_2.png";
                  } else if (selectedImageIndex.includes(3)) {
                    image = config.dummyBanner3url;
                    name = "Dummy Banner-Package_3.png";
                  }
                  docs.push({
                    file_size: "10000",
                    media_id: "662b4c87cd42d078129e64f9",
                    name: name,
                    file_name: image,
                  });
                }
                if (docs) {
                  let payload = {
                    package_name: editPackage["package_name"],
                    description: description["value"],
                    banner_image: docs,
                  };
                  let res = await updatePackagesAPI(
                    editPackage["_id"],
                    payload
                  );
                  if (res.error) {
                    toaster(res.message, "error", "error");
                    LoaderAnimation.hide();
                    return;
                  } else {
                    toaster(
                      "Package Updated Successfully",
                      "success",
                      "success"
                    );
                    let item = {
                      ...editPackage,
                      package_name: editPackage["package_name"],
                      description: description["value"],
                      banner_image: docs,
                    };
                    setEditPackage(item);
                    sessionStorage.setItem(
                      "package",
                      CryptoJS.AES.encrypt(
                        JSON.stringify(item),
                        config.packageKey
                      ).toString()
                    );
                    closeModal();
                  }
                }
              } else toaster("Enter all the details", "error", "error");
              LoaderAnimation.hide();
            }}
            text="Update"
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      );
    } else {
      return (
        <>
          {/* <Box
            width={MobileWindow && "50%"}
            justifyContent={MobileWindow && "center"}
            alignItems={MobileWindow && "center"}
          >
            <Text
              onPress={closeModal}
              color={COLORS.MODAL_BACK_BUTTON_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              mt={3}
              mr={12}
            >
              Back
            </Text>
          </Box> */}
          <Box width={MobileWindow && "100%"}>
            <CustomButton
              onPress={() => {
                closeModal();
                handleAction(actionName);
              }}
              text="Confirm"
              color={COLORS.WHITE_COLOR}
            />
          </Box>
        </>
      );
    }
  };

  return (
    <Box bg={COLORS.THEME_BACKGROUND} pb={8} minHeight={"100vh"}>
      <Box bg={COLORS.WHITE_COLOR} py={1}>
        {MobileWindow ? (
          <MobileHeader showTabs={false} />
        ) : (
          <WebHeader showTabs={false} />
        )}
        <Box pb={2} pt={4} px={!MobileWindow ? "5rem" : "1.5rem"}>
          <Breadcrumbs path={breadcrumbDetails} />
        </Box>
      </Box>
      <Box
        px={!MobileWindow ? "5rem" : "1.5rem"}
        pt={MobileWindow ? "20px" : "56px"}
      >
        <CommonHeading
          text={packageDetail.package_name}
          fontSize={MobileWindow ? "26px" : undefined}
        />
        {isLoading ? (
          <Box
            mt={5}
            mb={10}
            flex={1}
            alignItems="center"
            justifyContent="center"
          >
            <Spinner color={COLORS.THEME_COLOR} size="lg" />
          </Box>
        ) : (
          <>
            <Box
              width={!MobileWindow && "594px"}
              height={"273px"}
              borderRadius={"12px"}
              mt={MobileWindow ? "20px" : "33px"}
              mb={"22px"}
            >
              <Image
                source={{
                  uri: packageDetail["banner_image"][0]["file_name"].includes(
                    "https://"
                  )
                    ? packageDetail["banner_image"][0]["file_name"]
                    : config.bucketPath +
                      packageDetail["banner_image"][0]["file_name"],
                }}
                alt="image"
                width={"100%"}
                height={"100%"}
                borderRadius={"12px"}
                resizeMode="stretch"
              />
            </Box>
            <Text
              color={COLORS.PACKAGES_CARD_TEXT_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            >
              {packageDetail.description}
            </Text>
            <Text
              my={"16px"}
              color={COLORS.BLACK_COLOR}
              fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
            >
              Agency: {packageDetail.agency_name}
            </Text>
          </>
        )}
      </Box>
      {!isLoading && (
        <>
          {!MobileWindow &&
            hasPermission("APPROVE_PACKAGES") &&
            packageDetail["status"] === "pending" && (
              <HStack
                alignItems={"center"}
                bg={COLORS.WHITE_COLOR}
                w={"100%"}
                py={4}
                justifyContent={MobileWindow ? "center" : "flex-end"}
                space={MobileWindow ? 2 : 5}
                pr={MobileWindow ? 3 : 10}
                position={"fixed"}
                bottom={0}
              >
                <CustomButton
                  onPress={() => {
                    setActionName("reject");
                    openModal();
                  }}
                  text="Reject"
                  textColor={COLORS.REJECT_TEXT_COLOR}
                  isOutline
                  bgColor={COLORS.REJECT_TEXT_COLOR}
                  fontSize={
                    MobileWindow
                      ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                      : COMMONFONTSIZE.LARGE_FONT_SIZE
                  }
                />
                <CustomButton
                  onPress={() => {
                    setActionName("approve");
                    openModal();
                  }}
                  text={`Approve`}
                  bgColor={COLORS.THEME_COLOR}
                  textColor={COLORS.WHITE_COLOR}
                  fontSize={
                    MobileWindow
                      ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                      : COMMONFONTSIZE.LARGE_FONT_SIZE
                  }
                />
              </HStack>
            )}
          {!MobileWindow &&
            hasPermission("QUOTATION") &&
            !hasPermission("APPROVE_PACKAGES") &&
            packageDetail["status"] === "pending" && (
              <HStack
                alignItems={"center"}
                bg={COLORS.WHITE_COLOR}
                w={"100%"}
                py={4}
                justifyContent={MobileWindow ? "center" : "flex-end"}
                space={MobileWindow ? 2 : 5}
                pl={MobileWindow && 5}
                pr={MobileWindow ? 5 : 10}
                position={"fixed"}
                bottom={0}
              >
                <Box width={MobileWindow && "50%"}>
                  <CustomButton
                    onPress={() => {
                      setActionName("delete");
                      openModal();
                    }}
                    text="Delete"
                    textColor={COLORS.REJECT_TEXT_COLOR}
                    isOutline
                    bgColor={COLORS.REJECT_TEXT_COLOR}
                    fontSize={
                      MobileWindow
                        ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                        : COMMONFONTSIZE.LARGE_FONT_SIZE
                    }
                  />
                </Box>
                <Box width={MobileWindow && "50%"}>
                  <CustomButton
                    onPress={() => {
                      setActionName("edit");
                      setEditPackage(packageDetail);
                      setUploadImages(packageDetail["banner_image"][0].file_name);
                      if (
                        packageDetail["banner_image"][0]["name"].split(
                          "_"
                        )[0] === "Dummy Banner-Package" &&
                        selectedImageIndex.length === 0
                      ) {
                        setSelectedImageIndex([
                          parseInt(
                            packageDetail["banner_image"][0]["name"]
                              .split("_")[1]
                              .split(".")[0]
                          ),
                        ]);
                      } else {
                        setFiles([]);
                        setFiles(packageDetail["banner_image"]);
                      }
                      openModal();
                    }}
                    text={`Edit`}
                    textColor={COLORS.THEME_COLOR}
                    isOutline
                    bgColor={COLORS.THEME_COLOR}
                    fontSize={
                      MobileWindow
                        ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                        : COMMONFONTSIZE.LARGE_FONT_SIZE
                    }
                  />
                </Box>
              </HStack>
            )}
          {!MobileWindow ? (
            <CustomModal
              top={actionName === "edit" ? "50px" : undefined}
              isOpen={showModal}
              onClose={closeModal}
              header={getPopupModalTitle()}
              body={getModalChildren()}
              footer={getModalFooter()}
              width={actionName === "edit" ? "70%" : undefined}
            />
          ) : (
            <MobileModelSheet
              isOpen={showModal}
              onClose={closeModal}
              header={getPopupModalTitle()}
              body={getModalChildren()}
              position="hidden"
              footer={getModalFooter()}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default PackagesDetailsPage;
